import { render, staticRenderFns } from "./image-capture.vue?vue&type=template&id=504a1c20&scoped=true&"
import script from "./image-capture.vue?vue&type=script&lang=js&"
export * from "./image-capture.vue?vue&type=script&lang=js&"
import style0 from "./image-capture.vue?vue&type=style&index=0&id=504a1c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a1c20",
  null
  
)

component.options.__file = "image-capture.vue"
export default component.exports